import {
  ApartmentOutlined,
  BankOutlined,
  CalendarOutlined,
  DownloadOutlined,
  FileDoneOutlined,
  FileTextOutlined, HistoryOutlined,
  HomeOutlined,
  IdcardOutlined,
  NotificationOutlined,
  OrderedListOutlined,
  TagsOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';

//ACADEMIC_DEAN, ACADEMIC_INCHARGE,ACADEMIC_COORDINATOR,INCHARGE
const academicAdminMenu = [
  {label: 'Dashboard', icon: <HomeOutlined />, path: '/'},
  {label: 'Apply for Leave', icon: <IdcardOutlined />, path: '/apply_leave'},
  {label: 'Leave Requests for Approval', icon: <OrderedListOutlined />, path: '/leave_request'},
  {label: 'Leave History', icon: <HistoryOutlined />, path: '/leave_history'},
  // {label: 'Download Leave Reports', icon: <DownloadOutlined />, path: '/leave_report'},
  {label: 'Profile', icon: <UserOutlined />, path: '/profile'},
];

//Principal and Director
const seniorAdminMenu = [
  {label: 'Dashboard', icon: <HomeOutlined />, path: '/'},
  {label: 'Leave Requests for Approval', icon: <FileDoneOutlined />, path: '/leave_request'},
  {label: 'Apply for Leave', icon: <IdcardOutlined />, path: '/apply_leave'},
  {label: 'Leave History', icon: <HistoryOutlined />, path: '/leave_history'},
  {label: 'Announcement', icon: <NotificationOutlined />, path: '/announcements'},
  // {label: 'Download Leave Reports', icon: <DownloadOutlined />, path: '/leave_report'},
  {label: 'Profile', icon: <UserOutlined />, path: '/profile'},
];

const teachingStaffMenu = [
  {label: 'Dashboard', icon: <HomeOutlined />, path: '/'},
  {label: 'Apply for Leave', icon: <IdcardOutlined />, path: '/apply_leave'},
  {label: 'Leave History', icon: <HistoryOutlined />, path: '/leave_history'},
  {label: 'Profile', icon: <UserOutlined />, path: '/profile'},
];

const nonTeachingStaffMenu = [
  {label: 'Dashboard', icon: <HomeOutlined />, path: '/'},
  {label: 'Apply for Leave', icon: <IdcardOutlined />, path: '/apply_leave'},
  {label: 'Leave History', icon: <HistoryOutlined />, path: '/leave_history'},
  {label: 'Profile', icon: <UserOutlined />, path: '/profile'},
];
//SECURITY_OFFICER
const securityOfficerMenu = [
  {label: 'Dashboard', icon: <HomeOutlined />, path: '/'},
  {label: 'Apply for Leave', icon: <IdcardOutlined />, path: '/apply_leave'},
  {label: 'Leave History', icon: <HistoryOutlined />, path: '/leave_history'},
  {label: 'Profile', icon: <UserOutlined />, path: '/profile'},
];

const hodMenu =[
  {label: 'Dashboard', icon: <HomeOutlined />, path: '/'},
  {label: 'Leave Requests for Approval', icon: <FileDoneOutlined />, path: '/leave_request'},
  {label: 'Apply for Leave', icon: <IdcardOutlined />, path: '/apply_leave'},
  {label: 'Leave History', icon: <HistoryOutlined />, path: '/leave_history'},
  {label: 'Profile', icon: <UserOutlined />, path: '/profile'},
];

export const menuData = {
  'ADMIN': [
    {label: 'Dashboard', icon: <HomeOutlined />, path: '/'},
    {label: 'Colleges', icon: <BankOutlined />, path: '/colleges'},
    {label: 'Departments', icon: <ApartmentOutlined />, path: '/departments'},
    {label: 'Employees', icon: <TeamOutlined />, path: '/employees'},
    {label: 'Holidays', icon: <CalendarOutlined />, path: '/holidays'},
    {label: 'Leave Types', icon: <TagsOutlined />, path: '/leave_types'},
    {label: 'All College Leave Request', icon: <FileTextOutlined  />, path: '/leave_request'},
    {label: 'Announcement', icon: <NotificationOutlined />, path: '/announcements'},
    // {label: 'Download Leave Report', icon: <DownloadOutlined />, path: '/leave_report'},
    {label: 'Profile', icon: <UserOutlined />, path: '/profile'},
  ],
 
  'ACADEMIC_DEAN': academicAdminMenu,
  'ACADEMIC_INCHARGE': academicAdminMenu,
  'ACADEMIC_COORDINATOR': academicAdminMenu,
  'INCHARGE':hodMenu,
  'HOD':hodMenu,
  'PRINCIPAL': seniorAdminMenu,
  'DIRECTOR': seniorAdminMenu,
  'LAB_TECHNICIAN': teachingStaffMenu,
  'LAB_ASSISTANT': teachingStaffMenu,
  'TUTOR': teachingStaffMenu,
  'PROFESSOR': teachingStaffMenu,
  'ASSISTANT_PROFESSOR': teachingStaffMenu,
  'TEACHER': teachingStaffMenu,
  'LECTURER': teachingStaffMenu,
  'OFFICE_SUPERINTENDENT': academicAdminMenu,
  'REGISTRAR': academicAdminMenu,
  'TEACHING_STAFF': teachingStaffMenu,
  'NONTEACHING_STAFF': nonTeachingStaffMenu,
  'LIBRARIAN': nonTeachingStaffMenu,
  'PEON': nonTeachingStaffMenu,
  'SWEEPER': nonTeachingStaffMenu,
  'SECURITY': securityOfficerMenu,
  'CLERK': nonTeachingStaffMenu,
  'ACCOUNTANT': nonTeachingStaffMenu,
  'ASSISTANT_LIBRARIAN': nonTeachingStaffMenu,
  'RECTOR':nonTeachingStaffMenu,
};
